module.exports = __webpack_public_path__ + "static/logo_dark-ac5eca4454ec35089b1bc20c3feb3b63.svg";